import 'firebase/storage';

import { Injectable } from '@rxdi/core';
import * as firebase from 'firebase/app';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

interface InternalFile<T> {
  url: string;
  snapshot: T;
}

export type FileReference = InternalFile<firebase.storage.Reference>;

export type FirebaseFile = InternalFile<firebase.storage.UploadTaskSnapshot>;

@Injectable()
export class StorageProvider {
  private storageRef = firebase.storage().ref();
  uploadFile(cardId: string, file: File): Observable<FirebaseFile> {
    const uniqueHash = this.generateHash();
    const metadata = {
      customMetadata: {
        cardId,
        uniqueHash,
        fileName: file.name,
      },
    };
    return from(this.storageRef.child([cardId, uniqueHash].join('/')).put(file, metadata)).pipe(
      switchMap(async (snapshot) => ({
        snapshot,
        url: await snapshot.ref.getDownloadURL(),
      }))
    );
  }

  private generateHash() {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 30; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  readCardFiles(cardId: string) {
    return from(this.storageRef.child(cardId).list()).pipe(
      switchMap(({ items }) =>
        Promise.all(
          items.map(
            async (snapshot) =>
              ({
                snapshot,
                url: await snapshot.getDownloadURL(),
              } as FileReference)
          )
        )
      )
    );
  }

  deleteFile(cardId: string, uniqueHash: string) {
    return from(this.storageRef.child([cardId, uniqueHash].join('/')).delete());
  }
}
